// extracted by mini-css-extract-plugin
module.exports = {"formBox":"index_formBox_iwq5Q","inputItem":"index_inputItem_G84oG","input":"index_input_A_g9z"};